export default {

  setGlobalData(state, options) {
    state.globalData = options;
  },

}
